// extracted by mini-css-extract-plugin
export default {"select-item-style":"UpdateTmModal_select-item-style__d+9aZ","low-opacity":"UpdateTmModal_low-opacity__PWV3u"};